import { apiGet, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "ADMIN/EDIT_PIN";
export const SavePin = `${NAMESPACE}/REQUEST`;
export const GetPin = `${NAMESPACE}/GET_PIN`;

export const savePin = (data) => apiPut(SavePin, `users/pin`, data);

export const getPin = () => apiGet(GetPin, `users/pin`);
